import { render, staticRenderFns } from "./IntelligenceSkillsGap.vue?vue&type=template&id=0f72e793&scoped=true"
import script from "./IntelligenceSkillsGap.vue?vue&type=script&lang=js"
export * from "./IntelligenceSkillsGap.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceSkillsGap.vue?vue&type=style&index=0&id=0f72e793&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f72e793",
  null
  
)

export default component.exports